import ForgotPassword from "@components/ForgotPassword/ForgotPassword";
import styles from "./ForgotPasswordPage.module.css"

const ForgotPasswordPage = () => {
    return (<div className={styles.Wrapper}>
        <ForgotPassword/>
    </div>  );
}
 
export default ForgotPasswordPage;